import React, { useEffect } from "react";

export const TermsAndConditions = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container">
      <div className="termsPage">
        <h2>GLOBAL LEGAL DISCLAIMER & TERMS OF USE/CONDITIONS</h2>
        <p className="mb-3">
          <b>Last Updated:</b> 20.03.2025{" "}
        </p>
        <p className="mb-3">
          Welcome to <a href="https://waqarzaka.net/">www.waqarzaka.net</a> (the
          "Website"). By accessing or using this Website, you agree to the
          following disclaimers, terms, and policies. If you do not agree with
          any part of this disclosure, please discontinue use immediately.{" "}
        </p>

        <p className="mb-3">
          For <a href="https://waqarzaka.net/">www.waqarzaka.net</a> & All
          Associated Signal / Telegram / WhatsApp Groups
        </p>

        <h2>Educational & Informational Use Only</h2>
        <p>
          All content, crypto signals, trading strategies, commentary, or
          communications shared via{" "}
          <a href="https://waqarzaka.net/">www.waqarzaka.net</a> or its
          affiliated platforms (including but not limited to Signal, Telegram,
          WhatsApp, or email) are intended solely for educational and
          informational purposes.
        </p>
        <p className="mb-3">
          They are not a substitute for professional financial, legal, or tax
          advice.
        </p>

        <h2>
          No Financial Advice – Opinions Only (with Global Jurisdictional
          Disclaimer)
        </h2>
        <p className="mb-3">
          Waqar Zaka and his team may share personal opinions, trade setups, and
          buy/sell signals as part of their educational services. However, all
          such content is provided strictly for informational purposes and does
          not constitute financial advice, portfolio management, or a
          recommendation to trade any specific asset.
        </p>
        <p className="mb-3">You acknowledge and agree that:</p>
        <p className="mb-3">
          Waqar Zaka and his team are not licensed financial advisors, brokers,
          or investment professionals in any jurisdiction, including but not
          limited to:
        </p>
        <ul>
          <li>The United States (SEC, CFTC, FINRA),</li>
          <li>The United Kingdom (FCA),</li>
          <li>The European Union (ESMA),</li>
          <li>The United Arab Emirates (SCA, DFSA),</li>
          <li>Singapore (MAS) and all other global regulatory bodies.</li>
        </ul>
        <p className="mb-3">
          All information shared is general in nature, not customized to your
          financial circumstances, and does not establish any fiduciary duty or
          client-advisor relationship.
        </p>
        <p className="mb-3">
          Waqar Zaka and his team do not solicit, induce, or guarantee any
          outcome or return. Past performance is not indicative of future
          results.
        </p>
        <p className="mb-3">
          By using our content, you waive all claims of misrepresentation,
          reliance, market manipulation, or legal liability under any financial
          services or securities regulation worldwide.
        </p>
        <h2>No Guarantee of Results</h2>
        <p>
          We make no warranties, express or implied, regarding the accuracy,
          reliability, timeliness, or future performance of any content.
        </p>
        <p className="mb-3">
          You acknowledge that all forms of trading and investing carry inherent
          risks, including the loss of your entire capital.
        </p>
        <h2>Jurisdictional Restrictions</h2>
        <p>
          Our services are not intended for use in jurisdictions where the
          transmission or use of such content would be unlawful or restricted.
        </p>
        <p>
          You are solely responsible for ensuring your participation complies
          with local laws, financial regulations, and restrictions.
        </p>

        <h2>Limitation of Liability</h2>
        <p className="mb-3">
          Waqar Zaka and all related parties (including team members,
          affiliates, contractors, and contributors) shall not be held liable
          for any form of damages — direct, indirect, incidental, punitive, or
          consequential — including but not limited to:
        </p>

        <ul>
          <li>Loss of capital or profits,</li>
          <li>Missed trades or opportunities,</li>
          <li>Trading errors based on content reliance,</li>
          <li>Or emotional, legal, or financial distress.</li>
        </ul>

        <p className="mb-3">
          This limitation applies regardless of the legal theory, even if
          advised of the possibility of such damages.
        </p>

        <h2>Product Access & No Refund Policy</h2>
        <p className="mb-3">
          Upon successful payment, users are granted access to the WaqarZaka.net dashboard,
          which constitutes delivery of the digital product and its associated services.
          By completing the purchase and receiving dashboard access, the user acknowledges
          that the product has been fully delivered. Accordingly, all sales are final, and
          no refunds will be issued once access to the dashboard has been provided.
          Any refund requests submitted after gaining access will be declined. By proceeding
          with the purchase, you agree to this policy and confirm your understanding that
          access to the platform represents fulfillment of the service.
        </p>

        <h2>Personal Responsibility & Risk Acceptance</h2>
        <p className="mb-3">You are solely responsible for:</p>
        <ul>
          <li>Evaluating all shared information,</li>
          <li>Conducting your own due diligence,</li>
          <li>Consulting with a qualified financial professional,</li>
          <li>Making independent investment or trading decisions.</li>
        </ul>
        <p className="mb-3">
          By participating, you voluntarily assume all risks, and agree to
          indemnify and hold harmless Waqar Zaka and associated parties from any
          legal action, claim, or loss arising out of your use of our services.
        </p>
        <h2>No Refund – No Chargeback Policy</h2>
        <p>
          Due to the nature of digital and educational content, all payments
          made for services, access, or subscriptions are non-refundable.
        </p>
        <p className="mb-3">
          By proceeding with any payment, you waive any right to refunds,
          disputes, or chargebacks, regardless of perceived results or
          experience.
        </p>
        <h2>Binding Agreement</h2>
        <p className="mb-3">
          By accessing <a href="https://waqarzaka.net/">www.waqarzaka.net</a> or
          any related groups, you confirm that you:
        </p>
        <ul>
          <li>Have read, understood, and accepted this disclaimer in full,</li>
          <li>Enter into a binding agreement,</li>
          <li>
            And irrevocably waive any future legal claims based on reliance,
            misunderstanding, or dissatisfaction.
          </li>
        </ul>
        <p className="mb-3">
          This disclaimer shall be governed by applicable international and
          local laws, and any disputes shall be resolved under the jurisdiction
          Waqar Zaka or his company designates.
        </p>
        <p>
          <b>Final Note</b>
        </p>
        <p>You trade at your own risk.</p>
        <p>
          Waqar Zaka and his team are not responsible for your profits, losses,
          decisions, or emotions.
        </p>
        <p>Your risk. Your decision. Your responsibility.</p>

        <h2>GENERAL DISCLAIMER</h2>
        <p className="mb-3">
          This Website is for educational and informational purposes only. We do
          not provide financial, investment, legal, or tax advice. Any content,
          materials, or courses available on this platform should not be
          construed as professional financial guidance. Always consult a
          licensed financial advisor, attorney, or tax professional before
          making any trading or investment decisions.
        </p>
        <h2>No Financial Or Investment Advice</h2>
        <p className="mb-3">
          We are not financial advisors, brokers, or investment professionals.
          No content on this Website constitutes financial, investment, or legal
          advice. Any financial or trading decisions you make based on our
          content are strictly at your own risk. Past performance is not
          indicative of future results.
        </p>
        <h2>Risk Disclosure</h2>
        <p className="mb-3">
          Trading and investing involve substantial risk, including the
          potential loss of your entire investment. The cryptocurrency and forex
          markets are highly volatile and not suitable for all investors. Only
          invest funds that you can afford to lose.
        </p>
        <h2>Personal Responsibility</h2>
        <p className="mb-3">
          By using this Website, you acknowledge that you are solely responsible
          for your financial decisions. We do not guarantee any specific
          financial outcomes or success, and we are not liable for any losses or
          damages arising from the use of our materials. Testimonials or success
          stories are exceptional and not typical. <br />
        </p>
        <p className="mb-3">
          All content is provided “as is” and “as available,” with no warranties
          of accuracy, completeness, or reliability. Although we strive to keep
          information current, we make no guarantees that all content is free
          from errors or outdated material.
        </p>
        <h2>Third-Party Links And Affiliates</h2>
        <p className="mb-3">
          This Website may include links to third-party websites, sponsored
          content, or affiliate promotions. We do not own or control third-party
          services and are not responsible for their accuracy, reliability, or
          legitimacy. Interactions with these services are at your own risk. We
          may receive commissions from affiliate links, but our content is not
          influenced by these affiliations.
        </p>
        <h2>Privacy Policy</h2>
        <p className="mb-3">
          By using this Website, you acknowledge that you have read and agreed
          to our Privacy Policy, which explains:
          <ul className="mt-3">
            <li>
              What personal data we collect (e.g., email, payment details,
              analytics)
            </li>
            <li>How we use and store that data</li>
            <li>Our third-party sharing practices</li>
            <li>Your rights, including how to request data deletion</li>
          </ul>
          Refer to the full [Privacy Policy] page for more information.
        </p>
        <h2>Billing, Payments, & Subscriptions</h2>
        <h5>1. Support Ticket Requirement for Payment Issues</h5>

        <p>
          If you experience any issues accessing the platform{" "}
          <b>after a successful payment</b>, you must first create a support
          ticket via our Help Desk. Our support team will aim to resolve your
          issue <b>within 48 hours</b>.
        </p>
        <p>
          If your issue is not resolved after 48 hours, you may then proceed to
          open a <b>payment dispute or refund request</b> via Stripe.
        </p>
        <p className="mb-3">
          <b>⚠️ Important: </b> Initiating a dispute without first creating a
          support ticket is a violation of our terms and may result in denied
          claims.
        </p>
        <h5>2. Auto-Renewal Subscription Policy</h5>

        <p className="mb-3">
          By subscribing to our platform, you acknowledge and agree that your{" "}
          <b>subscription renews automatically every month</b>.
          <ul className="mt-3">
            <li>The first payment will require your authorization.</li>
            <li>
              Subsequent payments will be automatically deducted from your
              credit card without requiring re-authorization. <br /> You may
              cancel the subscription at any time before the next billing cycle
              through your account settings.
            </li>
          </ul>
        </p>
        <h2>Refund Policy</h2>
        <p className="mb-3">
          All sales of digital products, including courses and subscriptions,
          are <b>final and non-refundable</b>, except in cases of{" "}
          <b>accidental duplicate purchases</b>.
        </p>
        <h2>Content Usage & User Conduct</h2>
        <ul>
          <li>
            Users may not copy, distribute, or reproduce any content without{" "}
            <b>written permission</b>.
          </li>
          <li>Unauthorized use of our content may result in legal action.</li>
          <li>
            Users must not engage in fraud, harassment, illegal activities, or
            violation of these terms.
          </li>
          <li>
            We reserve the right to <b>suspend or terminate any user account</b>{" "}
            that violates these terms.
          </li>
        </ul>
        <h2>Limitation Of Liability</h2>
        <p className="mb-3">
          To the fullest extent permitted by law, we shall not be liable for any
          direct, indirect, incidental, consequential, or special damages
          arising from:
        </p>
        <ul>
          <li>Use of or inability to use our Website</li>
          <li>Errors or inaccuracies in content</li>
          <li>Third-party services or external links</li>
          <li>Loss of profits, revenue, or financial data</li>
        </ul>
        <h2>Modifications</h2>
        <p>
          We reserve the right to update or modify this legal disclaimer and
          terms of use at any time without prior notice. It is your
          responsibility to check this page regularly for updates.
        </p>
      </div>
    </div>
  );
};
